import { CSSProperties } from 'react';

// Calm transition band: a tri-colour masked line with a gliding diamond.
const LINE_STYLE: CSSProperties = {
  background:
    'linear-gradient(90deg,transparent,#FDE47A 22%,#7fa8ff 50%,#6ed7a6 78%,transparent)',
  WebkitMask:
    'linear-gradient(90deg,transparent,#000 18%,#000 82%,transparent)',
  mask: 'linear-gradient(90deg,transparent,#000 18%,#000 82%,transparent)',
};

export const Separator2 = () => (
  <div className={styles.band} aria-hidden="true">
    <div className={styles.lineWrap}>
      <span className={styles.line} style={LINE_STYLE} />
      <span className={styles.diamond} style={{ left: '50%' }} />
    </div>
  </div>
);

const styles = {
  band: 'flex h-[140px] items-center justify-center overflow-hidden bg-mf-navy',
  lineWrap: 'relative h-[2px] w-[min(560px,74%)]',
  line: 'absolute inset-0 rounded-[2px] opacity-85',
  diamond:
    'absolute top-1/2 h-[9px] w-[9px] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-[2px] bg-white shadow-[0_0_12px_rgba(255,255,255,0.85)] motion-safe:animate-sep-glide',
};
